var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import Text from './Text';

var ShortText = function (_Text) {
  _inherits(ShortText, _Text);

  function ShortText() {
    var _temp, _this, _ret;

    _classCallCheck(this, ShortText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Text.call.apply(_Text, [this].concat(args))), _this), _this.maxLength = function () {
      return Number(_this.props.maxLength || 1);
    }, _this.isValid = function (value) {
      return (value || '').length <= _this.maxLength();
    }, _this.helpText = function (value) {
      if (_this.isValid(value)) {
        return '';
      }

      var max = _this.maxLength();
      return 'The text you entered is too long (max=' + max + ')';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ShortText;
}(Text);

ShortText.propTypes = _extends({}, Text.propTypes, {
  maxLength: PropTypes.number.isRequired
});

export default ShortText;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/ShortText.js
// module id = 714
// module chunks = 0